import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/libs/util'
// import { saveErrorLogger } from '@/api/data'
import router from '@/router'
import routers from '@/router/routers'
import config from '@/config'
const { homeName } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}
function showBanOperatInit() {
  return { // 全局展示封禁输入名称校验的输入框
    show: false, // 是否展示
    count: 0, // 请求参数
    type: '',
    // beforeShow: false, // push到全局globalMethodArr内的方法重新执行时，不会重新再显示一次输入框，放在<=5的条件后（有需要使用的方法才使用这个）
  }
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false,
    faqChangeNum:0,
    givingNum:0,
    pageNum:1,
    tabNum:0,

    showPasswordFlag: false, // 全局展示输入密码框

    showBanOperatFlag: showBanOperatInit(),
    initBanOperatFlag: showBanOperatInit(), // 暴露初始化operatFlag给store
  },
  getters: {
    menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    errorCount: state => state.errorList.length,
    showPasswordFlag: state => state.showPasswordFlag,
    showBanOperatFlag: state => state.showBanOperatFlag,
    initBanOperatFlag: state => state.initBanOperatFlag,
  },
  mutations: {
    faqChagee(state){
      state.faqChangeNum= state.faqChangeNum+1
    },
    changeGiving(state){
      state.givingNum= state.givingNum+1
    },
    setpageNum(state,page){
      state.pageNum=page
    },
    settabNum(state,page){
      state.tabNum=page
    },
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName)
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else tagList = getTagNavListFromLocalstorage() || []
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name == homeName)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, { route, type = 'unshift' }) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type == 'push') state.tagNavList.push(router)
        else {
          if (router.name == homeName) state.tagNavList.unshift(router)
          else state.tagNavList.splice(1, 0, router)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },

    addError (state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus (state, status = true) {
      state.hasReadErrorPage = status
    },
    setShowPasswordFlag(state, status) {
      state.showPasswordFlag = status;
    },
    setShowBanOperatFlag(state, status) {
      Object.keys(status).forEach(statusItem => {
        state.showBanOperatFlag[statusItem] = status[statusItem];
      });
      state.showBanOperatFlag = Object.assign({}, state.showBanOperatFlag);
    }
  },
  actions: {
    addErrorLog ({ commit, rootState }, info) {
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
      const { user: { token, userId, userName } } = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      // saveErrorLogger(info).then(() => {
      //   commit('addError', data)
      // })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js